import RenderPanel from './RenderPanel';

export default RenderPanel;
